import en_us from './en-us.json';
import zh_tw from './zh-tw.json';

export default {
  'en-US': en_us,
  'zh-TW': zh_tw,
};
